import { render, staticRenderFns } from "./salesBill.vue?vue&type=template&id=2661c939&scoped=true&"
import script from "./salesBill.vue?vue&type=script&lang=js&"
export * from "./salesBill.vue?vue&type=script&lang=js&"
import style0 from "./salesBill.vue?vue&type=style&index=0&id=2661c939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661c939",
  null
  
)

export default component.exports